import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { SUMMARY_KEY } from './keys';
import { EnrollApi } from 'api';

function useGetSummary(id: string) {
  return useAuthQuery(
    getQueryKeys(SUMMARY_KEY).detail(id),
    () => EnrollApi.getSummary(id),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetSummary;
